module.exports = __webpack_public_path__ + "static/media/pic9.799ba492.jpg";